import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const NEUTRAL_MESSAGE =
  "Se l'indirizzo è associato a un account FullBook, riceverai le istruzioni per reimpostare la password.";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch (err) {
      setError(
        err?.response?.status === 429
          ? "Hai effettuato troppe richieste. Riprova tra un minuto."
          : err?.userMessage || "Non è stato possibile inviare la richiesta. Riprova."
      );
    }
  };

  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="min-h-screen flex items-center justify-center bg-slate-50 px-5 py-8 outline-none"
      data-testid="forgot-password-page"
    >
      <section className="w-full max-w-md rounded-sm bg-white p-6 shadow-sm sm:p-10">
        <p className="section-title text-3xl font-bold text-slate-900">FullBook</p>
        <h1 className="mt-8 text-2xl font-semibold text-slate-950">Password dimenticata?</h1>
        {submitted ? (
          <div className="mt-5 space-y-5">
            <p className="text-sm leading-6 text-slate-700" role="status" data-testid="forgot-password-success">
              {NEUTRAL_MESSAGE}
            </p>
            <Link
              to="/login"
              className="inline-flex h-11 w-full items-center justify-center rounded-sm bg-slate-900 px-4 font-medium text-white"
              data-testid="forgot-password-back-link"
            >
              Torna ad Accesso
            </Link>
          </div>
        ) : (
          <form className="mt-5 space-y-5" onSubmit={handleSubmit}>
            <p className="text-sm leading-6 text-slate-600">
              Inserisci l&apos;email del titolare. Se è associata a un account FullBook, riceverai un link per reimpostare la password.
            </p>
            <div>
              <label htmlFor="forgot-password-email" className="text-xs uppercase tracking-[0.2em] text-slate-500">
                Email
              </label>
              <input
                id="forgot-password-email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="mt-2 h-10 w-full rounded-sm border border-slate-200 px-3"
                data-testid="forgot-password-email-input"
              />
            </div>
            {error && (
              <div className="text-sm text-red-600" role="alert" data-testid="forgot-password-error">
                {error}
              </div>
            )}
            <button
              type="submit"
              className="h-11 w-full rounded-sm bg-slate-900 font-medium text-white"
              data-testid="forgot-password-submit"
            >
              Invia istruzioni
            </button>
            <Link to="/login" className="block text-center text-sm text-slate-700 underline underline-offset-4">
              Torna ad Accesso
            </Link>
          </form>
        )}
      </section>
    </main>
  );
}
